/**
 * Multi-module token storage.
 * Tokens are stored in-memory only (never persisted to localStorage for security).
 */

let tokens = {};

export const tokenManager = {
  setTokens(newTokens) {
    tokens = { ...tokens, ...newTokens };
  },

  getToken(module) {
    return tokens[module] || null;
  },

  getAipToken() {
    return tokens['zehn-aip'] || null;
  },

  getAllModuleTokens() {
    const { 'zehn-aip': _aip, ...moduleTokens } = tokens;
    return moduleTokens;
  },

  clearTokens() {
    tokens = {};
  },

  hasToken(module) {
    return !!tokens[module];
  },
};
